module.exports = __webpack_public_path__ + "img/me.3db34cc2.jpg";